/**
 * 비밀번호 유효성 검사 결과
 */
export interface PasswordValidation {
  isValid: boolean;
  error?: string;
}

export interface PasswordOptions {
  /** 최소 길이 */
  minLength?: number;
  /** 최대 길이 */
  maxLength?: number;
}

/**
 * 비밀번호 유효성 검사
 * @param value - 비밀번호
 * @param options - 검증 옵션
 * @returns 유효성 검사 결과
 *
 * @example
 * validatePassword('12345') // { isValid: false, error: '8자 이상의 비밀번호를 입력해주세요' }
 * validatePassword('12345678') // { isValid: true }
 */
export const validatePassword = (
  value: string,
  options: PasswordOptions = { minLength: 8, maxLength: 20 },
): PasswordValidation => {
  const { minLength = 8, maxLength = 20 } = options;

  if (!value || value.length === 0) {
    return { isValid: false, error: '' };
  }

  if (value.length < minLength) {
    return { isValid: false, error: `${minLength}자 이상 입력해주세요` };
  }

  if (value.length > maxLength) {
    return { isValid: false, error: `${maxLength}자까지 입력할 수 있어요` };
  }

  return { isValid: true };
};
